import { Column } from 'hooks/useMuiTableBuilderV2';
import { TeamSearchSortBy } from 'TeamModule/api/searchTeamsByFieldsApi';

export const COLUMNS = {
  CHECKBOX: 'checkbox',
  TENANT: 'tenant',
  REALM: 'realm',
  TEAM_ID: 'team_id',
  TEAM_NAME: 'team_name',
  ARCHIVED_AT: 'archived_at',
  DELETION_DATE: 'deletion_date',
  DEVELOPER_APPROVAL: 'developer_approval',
  SUPPORT_APPROVAL: 'support_approval',
  REASON: 'reason',
};

const checkboxColumn: Column = {
  id: COLUMNS.CHECKBOX,
  label: '',
  sortDisabled: true,
};

const tenantColumn: Column = {
  id: COLUMNS.TENANT,
  label: 'Tenant',
  sortDisabled: true,
};

const realmColumn: Column = {
  id: COLUMNS.REALM,
  label: 'Realm',
  sortDisabled: true,
};

const teamIdColumn: Column = {
  id: COLUMNS.TEAM_ID,
  label: 'Team ID',
};

const teamNameColumn: Column = {
  id: COLUMNS.TEAM_NAME,
  label: 'Team Name',
};

const archivedAtColumn: Column = {
  id: COLUMNS.ARCHIVED_AT,
  label: 'Archive Date',
};

const deletionDateColumn: Column = {
  id: COLUMNS.DELETION_DATE,
  label: 'Scheduled Deletion',
};

const developerApprovalColumn: Column = {
  id: COLUMNS.DEVELOPER_APPROVAL,
  label: 'Developer Approval',
};

const supportApprovalColumn: Column = {
  id: COLUMNS.SUPPORT_APPROVAL,
  label: 'Support Approval',
};

const reasonColumn: Column = {
  id: COLUMNS.REASON,
  label: 'Reason',
  sortDisabled: true,
};

export const columns: Column[] = [
  checkboxColumn,
  tenantColumn,
  realmColumn,
  teamIdColumn,
  teamNameColumn,
  archivedAtColumn,
  deletionDateColumn,
  developerApprovalColumn,
  supportApprovalColumn,
  reasonColumn,
];

export const SORT_BY_MAP: Partial<Record<keyof typeof COLUMNS, TeamSearchSortBy>> &
  Record<string, TeamSearchSortBy | undefined> = {
  [COLUMNS.TEAM_ID]: 'teamId',
  [COLUMNS.TEAM_NAME]: 'name',
  [COLUMNS.ARCHIVED_AT]: 'archivedAt',
  [COLUMNS.DELETION_DATE]: 'dataDeletionScheduledDate',
  [COLUMNS.DEVELOPER_APPROVAL]: 'developerApproved',
  [COLUMNS.SUPPORT_APPROVAL]: 'supportApproved',
};
